export default __webpack_public_path__ + "static/clinician-portrait-acef4fdf90064550ca3bbf9cd259b6ad.jpg";